import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import config from '../config.js';

// console log spécial pour

// Fonction pour récupérer les données du cache depuis sessionStorage
export const getFromCache = (cacheKey) => {
    console.debug("Cache utilisé : " + cacheKey);
    const cachedData = sessionStorage.getItem(cacheKey);
    return cachedData ? JSON.parse(cachedData) : null;
};

// Fonction pour mettre en cache les données dans sessionStorage
export const cacheResponse = (cacheKey, responseData) => {
    console.debug("Données mise en cache pour : " + cacheKey);
    sessionStorage.setItem(cacheKey, JSON.stringify(responseData));
};

// Fonction pour supprimer un élément du cache dans sessionStorage
export const removeFromCache = (cacheKey) => {
    console.debug("Cache supprimé : " + cacheKey);
    sessionStorage.removeItem(cacheKey);
};

export const callAPI = (method, params) => {
    const api_url = config.getURL('api');
    const endpoint = 'clients';
    // const use_cache = typeof params.use_cache !== 'undefined' ? params.use_cache : true;
    const use_cache = false;

    // const api_url = 'meoboard.dev.1.meosis.fr/';
    // const endpoint = '';

    const requestOptions = {
        method: 'POST',
        // headers: {
        //     'Content-Type': 'application/json', // Indique que le corps de la requête est en format JSON
        //     // Autres en-têtes si nécessaire
        // },
        body: JSON.stringify(params), // Convertit les paramètres en JSON
    };
    
    // Créer une clé de cache unique basée sur l'endpoint, la méthode et les paramètres
    const cacheKey = `${method}`;

    if (use_cache) {
        // Vérifier si la réponse existe dans le cache
        const cachedResponse = getFromCache(cacheKey);
        if (cachedResponse) {
            console.log('Returning cached data');
            return Promise.resolve(cachedResponse);
        }
    }
   

    return fetch(`${api_url}${endpoint}${method ?? ''}`, requestOptions)
        .then((response) => {
            // Gestion du cas particulier : 204 No Content
            // if (response.status === 204) {
            //     console.debug('✅ Réponse 204 : Aucun contenu à traiter');
            //     return { success: true, msg: null }; // Réponse neutre
            // }

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then((response) => {
            // Traitez les données récupérées ici
            if (response.success == 1) {
                if (response.msg) {
                    toast.success(response.msg)
                }
            }
            else {
                toast.error(response.msg)
            }

            // Mettre en cache la réponse
            if (use_cache) {
                cacheResponse(cacheKey, response);                
            }

            console.debug(response);

            return response;

        })
        .catch((error) => {
            // Gérez les erreurs ici
            console.error('Fetch error:', error);
        });
}